export function formatNumber(value) {
    if (value == null) {
        return null;
    }
    let n = 0;
    if (!Number.isInteger(value)) {
        n = 2;
    }
    let s = " ";
    let re = '\\d(?=(\\d{3})+' + (n > 0 ? '\\D' : '$') + ')';
    let num = value.toFixed(n);
    return num.replace(new RegExp(re, 'g'), '$& ' + s);
}
